import { FC } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

/**
 * 地图踩点-点覆盖物图标
 * @description
 * @demo
 */
const Component:FC<{
  /** 是否激活 */
  active?: boolean
  isPad?: boolean;
}> = ({ active = false, isPad = false }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={cs([styles.markerIconDom, isPad && styles.markerIconDomInPad, 'siteselectionsandmap-foot-print-marker-icon'])}>
    <img className={cs(active && styles.active)} src='https://staticres.linhuiba.com/project-custom/locationpc/flow/fixed_point2.png' />
  </div>);
};

export default Component;
